// extracted by mini-css-extract-plugin
export var button = "_dc-0";
export var icon = "_dc-1";